import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'CLEAR LABELED DIAGRAMS.', 'STEP-BY-STEP PROCEDURES.', '❌/✅ COMPARISONS.', 'READY LAB PROJECTS.', 'CLEAR ASSESSMENT CRITERIA.', 'READY-TO-TEACH CLASSES.', 'BETTER CLASS PREPARATION.'];
const alreadyHave = ['You already have the circuit theory, meter and electrical safety visuals.', 'You already have the residential wiring, panel and circuit protection guides.', 'You already have the three-phase, motor and control circuit sequences.', 'You already have the diagram, testing and troubleshooting methods.', 'You already have the PLC, VFD and smart system workflows.', 'You already have the lesson plans, course programs and practical assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-[#D2DCEC]" data-id="element-68" data-mp="216e4zbu8ztdm">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-69" data-mp="1wct51e93gpbs">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#0B1F4D] mb-6 uppercase" data-id="element-70" data-mp="1v61ofonun2mi">
          You Don&apos;t Need More Scattered <span className="text-[#1236C0]" data-id="element-71" data-mp="203l9b7f1ydnf">Electrical Teaching Resources.</span>
        </h2>
        <p className="text-xl text-slate-700/80 mb-5" data-id="element-72" data-mp="1l6u94vxk0xwr">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-73" data-mp="1q6gj8wi35y1c">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-[#0B1F4D] tracking-wide" data-id="element-74" data-mp="1c7pcxw9gtgnr">
              {need}
            </li>)}
        </ul>
        <div className="bg-[#F3F6FC] border border-[#D2DCEC] rounded-2xl p-8 text-lg text-slate-700 space-y-2 text-left sm:text-center" data-id="element-75" data-mp="36kyoruphhe96">
          <p className="mb-4" data-id="element-76" data-mp="3bkb7q4d8i16h">
            With ELECTRICAL TECHNOLOGY INSTRUCTOR ATLAS, you don&apos;t start every class searching through
            books, handouts, videos and old notes.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-[#0B1F4D] font-semibold flex items-center sm:justify-center gap-2" data-id="element-77" data-mp="355w0x32mbgwt">
              <Check size={18} className="text-[#1236C0] shrink-0" aria-hidden="true" data-id="element-78" data-mp="2v6erqbo5qkw3" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-79" data-mp="3sskjlqzgbdeh">
            And with the five exclusive bonuses, you also have electrical formulas and wiring quick-reference charts,
            demonstration lesson scripts, a circuit-building lab projects and wiring exercise workbook, electrical symbols
            and fault-finding flashcards, and competency checklists, rubrics and certificates to help you plan, teach,
            correct and assess your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0B1F4D]" data-id="element-80" data-mp="an8xq3a8rbxl">
            YOU ALREADY HAVE <span className="text-[#1236C0]" data-id="element-81" data-mp="hzowa4ax0qmr">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}